'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _Constants = require('../../Constants');


var _components = require('../../../../components');


var _ModalError = require('./ModalError.scss');var styles = _interopRequireWildcard(_ModalError);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Components

var ModalError = function ModalError(_ref)




{var isOpen = _ref.isOpen,onRequestClose = _ref.onRequestClose,translate = _ref.translate,error = _ref.error;var _getErrorKeyCase =
  (0, _Constants.getErrorKeyCase)(error && error.details && error.details.errorKey),title = _getErrorKeyCase.title,subTitle = _getErrorKeyCase.subTitle;

  return (
    _react2.default.createElement(_components.Modal, {
        isOpen: isOpen,
        className: styles.modal,
        onRequestClose: onRequestClose },

      _react2.default.createElement('div', { className: styles.failModalContentWrapper },
        _react2.default.createElement('p', { className: styles.failModalTitle }, translate('myStaff', 'errorKeys', title)),
        subTitle && _react2.default.createElement('p', { className: styles.failModalSubTitle }, translate('myStaff', subTitle)),
        _react2.default.createElement('button', {
            onClick: onRequestClose,
            className: styles.failModalButton },

          translate('myStaff', 'return')))));




}; // Styles
// Helpers
ModalError.propTypes = {
  translate: _propTypes2.default.func,
  isOpen: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  error: _propTypes2.default.object };exports.default =


ModalError;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/ModalError/ModalError.js
// module id = 2974
// module chunks = 0